import { createReducer, on } from "@ngrx/store";
import { IStaffList } from "../../models/staffList";
import { IStaff } from "../../models/user";
import { resetAppState } from "../global/global.actions";
import { StaffActions } from "./staff.actions";

export const staffFeatureKey = 'staff';

export interface StaffState {
    staff: IStaffList | null
    selectedStaff: IStaff | null;
    error: any;
}

export const initialState: StaffState = {
    staff: null,
    selectedStaff: null,
    error: null
};

export const staffReducer = createReducer(
    initialState,
    on(StaffActions.loadStaffSuccess, (state, { staffList }) => ({
        ...state,
        staff: staffList,
        error: null // Clear any previous errors on successful load
    })),
    on(StaffActions.loadStaffFailure, (state, { error }) => ({
        ...state,
        error
    })),
    on(StaffActions.selectStaff, (state, { id }) => {
        const selectedStaff = state.staff?.teachers.find(staffMember => staffMember.id === id)
            || state.staff?.executives.find(staffMember => staffMember.id === id)
            || state.staff?.subjectHeads.find(staffMember => staffMember.id === id)
            || state.staff?.coaches.find(staffMember => staffMember.id === id)
            || null;
        return {
            ...state,
            selectedStaff
        };
    }),
    on(resetAppState, () => initialState)
);
